import { render, staticRenderFns } from "./AppFooterSeguros.vue?vue&type=template&id=753af840&scoped=true"
import script from "./AppFooterSeguros.vue?vue&type=script&lang=js"
export * from "./AppFooterSeguros.vue?vue&type=script&lang=js"
import style0 from "./AppFooterSeguros.vue?vue&type=style&index=0&id=753af840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753af840",
  null
  
)

export default component.exports